import React from 'react';
import cx from 'clsx';
import throttle from 'lodash-es/throttle';

import ArrowUpIcon from '~/assets/icons/ic__system__arrow_up__outline.svg';

export interface ScrollTopProps {
  visibilityHeight?: number;
  onClick?: () => void;
}

const ScrollTop: React.FC<ScrollTopProps> = ({
  visibilityHeight = 400,
  onClick,
}) => {
  const [visible, setVisible] = React.useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    onClick?.();
  };

  React.useEffect(() => {
    const bindScrollEvent = throttle(() => {
      setVisible(visibilityHeight < window.scrollY);
    }, 250);

    setVisible(visibilityHeight < window.scrollY);
    window.addEventListener('scroll', bindScrollEvent);

    return () => window.removeEventListener('scroll', bindScrollEvent);
  }, [visibilityHeight]);

  return (
    <button
      data-testid="component_scroll-top"
      className={cx([
        '  flex w-40 h-40 items-center justify-center bg-warmGray-000 rounded-full shadow-[0_4px_8px_rgb(0_0_0_/_10%)]',
        !visible && 'invisible',
      ])}
      type="button"
      onClick={scrollToTop}
    >
      <ArrowUpIcon />
    </button>
  );
};

export default ScrollTop;
